export default __webpack_public_path__ + "static/media/26075_37.1b79484f.svg";